import React from 'react';
import { ListActionButton } from './ListActionButton';
import { ActionIconName } from '../Icons/action-icon';
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const buttonColumnMinWidth = 40;
const buttonColumnMaxWidth = 45;
const buttonColumnResizeable = true;
const renderActionButton = (action, onClick) => {
  return (_item, index, column) => {
    if (column === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
    if (index === undefined) return /*#__PURE__*/_jsx(_Fragment, {});
    return /*#__PURE__*/_jsx(ListActionButton, {
      iconName: action,
      index: index,
      onClick: () => {
        onClick(index);
      }
    });
  };
};
export function deleteDetailListColumn(onClick) {
  return {
    key: 'deleteButton',
    name: '',
    fieldName: 'deleteButton',
    minWidth: buttonColumnMinWidth,
    maxWidth: buttonColumnMaxWidth,
    isResizable: buttonColumnResizeable,
    onRender: renderActionButton(ActionIconName.Delete, onClick)
  };
}
export function editDetailListColumn(onClick) {
  return {
    key: 'editButton',
    name: '',
    fieldName: 'editButton',
    minWidth: buttonColumnMinWidth,
    maxWidth: buttonColumnMaxWidth,
    isResizable: buttonColumnResizeable,
    onRender: renderActionButton(ActionIconName.Edit, onClick)
  };
}